import React from 'react';
import { createPortal } from 'react-dom';
import SearchInput from './searchInput';

const SearchInputPortal = () => createPortal(<SearchInput />, document.getElementById('SearchInput'));

export default SearchInputPortal;
